module.exports = __webpack_public_path__ + "img/right.9e57e39a.svg";